import React from 'react';
import {
  CoachingReservation,
  SavedCoachingReservation,
} from 'coaching/containers/GetAvailableReservationsContainer';

import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Copy from 'components/Copy';
import Text from 'components/Text';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import TextWithIcon from 'components/TextWithIcon';
import EventTracking from 'lib/EventTracking';

type Props = {
  onSignIn: () => void;
  reservation?: CoachingReservation | SavedCoachingReservation;
  subject?: string;
  childName?: string;
  userTimezone: string;
};

export const coachingSelfServeTranstionToSignUpPrefix = 'coaching.sign_up_funnel.transition_to_sign_up';

export default function CoachingSelfServeTransitionToSignup(props: Props) {
  const { onSignIn, reservation, subject, childName, userTimezone } = props;

  React.useEffect(() => {
    EventTracking.trackKey(`${coachingSelfServeTranstionToSignUpPrefix}.view`);
  }, []);

  const dateFormatted = reservation?.startDateTime
    .clone()
    .tz(userTimezone)
    .format('ddd, MMM D [at] LT (z)');
  const reservationMinutesDuration = reservation?.endDateTime.diff(
    reservation?.startDateTime,
    'minutes'
  );
  return (
    <>
      <Row size="small">
        <Heading level="1" serif flush>
          <Text data-test="transition-signup-header" color="ink" weight="semibold">
            Confirm with an account
          </Text>
        </Heading>
      </Row>
      <Row size="xxxxlarge">
        <Copy align="left" size="small">
          <Text data-test="transition-signup-copy-header" size="xsmall" weight="semibold">
            Once you log in or sign up, we’ll confirm your free first session!
          </Text>
        </Copy>
      </Row>
      <Row size="large">
        <Box color="eraser" textAlign="left" noShadow>
          <BoxBody size="xsmall">
            <Row size="xxsmall">
              <Text
                data-test="transition-signup-copy-subject-detail"
                size="xsmall"
                weight="semibold">
                {`${subject} for ${childName}`}
              </Text>
            </Row>
          </BoxBody>
          <BoxBody light size="xsmall" rounded>
            <Row size="xxsmall">
              <Text size="xsmall" color="graphite">
                Free first session
              </Text>
            </Row>
            <Row size="xxsmall">
              <TextWithIcon
                data-test="transition-signup-copy-date"
                icon="clock"
                size="xsmall"
                weight="semibold">
                {dateFormatted} • {reservationMinutesDuration} min
              </TextWithIcon>
            </Row>
          </BoxBody>
        </Box>
      </Row>
      <Button
        data-test="transition-signup-login"
        color="koolaid"
        eventKey={`${coachingSelfServeTranstionToSignUpPrefix}.button.click`}
        onClick={onSignIn} >
        Log in or sign up
      </Button>
    </>
  );
}
